export type GlobalConf = Record<string, unknown>;

export const EXECUTION_URL_SETTING = 'prophecy.ui.execution.url';

/** `/api/globalConf` answers one `{key: value}` object per setting. */
export function mergeGlobalConf<T extends GlobalConf = GlobalConf>(entries: readonly T[] | null | undefined): T {
  let settings = {} as T;
  (entries || []).forEach((entry) => {
    settings = { ...settings, ...entry };
  });
  return settings;
}

/** A failed call reads as no settings, so every setting takes its default. */
export async function fetchGlobalConf<T extends GlobalConf = GlobalConf>(
  get: () => Promise<readonly T[] | null | undefined>
): Promise<T> {
  try {
    return mergeGlobalConf(await get());
  } catch (error) {
    console.error(error);
    return {} as T;
  }
}

export function executionServiceUrlSetting(settings: GlobalConf): string | undefined {
  const setting = settings[EXECUTION_URL_SETTING];
  return typeof setting === 'string' ? setting : undefined;
}
